module.exports = __webpack_public_path__ + "static/MO-09af85f839e512beba82f7841e31383e.svg";